<button class="fm-close-street-view fab fab-secondary fab-md"
  i18n-aria-label="@@S_CLOSE_BUTTON" aria-label="Close" 
  (click)="onClick()">
  <mat-icon svgIcon="ds-ic-close"
    class="mat-icon-size-xs"></mat-icon>
</button>
